import { apiClient } from "./apiClient";

export const FO_DOT_DANG_KY_PHAM_VI_API_END_POINT = "food/dot-dang-ky-pham-vi";

export const foDotDangKyPhamViApi = {
    select_all: () => apiClient.get(FO_DOT_DANG_KY_PHAM_VI_API_END_POINT),
    select_by_dot_dang_ky: (fo_dotdangky_an_id: number) => apiClient.get(`${FO_DOT_DANG_KY_PHAM_VI_API_END_POINT}/dot-dang-ky/${fo_dotdangky_an_id}`),
    select_by_truong: (dm_truong_id: number) => apiClient.get(`${FO_DOT_DANG_KY_PHAM_VI_API_END_POINT}/truong/${dm_truong_id}`)
};
